/** Preserve only the pending OAuth approval route, never a URL supplied by the caller. */
export function mcpLoginReturnTo(pathname: string, search: string, hash: string): string {
  const route = hash.split('?')[0];
  if (!/^#\/mcp\/consent\/[A-Za-z0-9_-]+$/.test(route)) return '/login';
  const destination = pathname + search + hash;
  return `/login?returnTo=${encodeURIComponent(destination)}`;
}

/** Only an exact, locally generated consent returnTo is handled by the SPA. */
export function mcpConsentSpaRoute(returnTo: string): string | null {
  const match = /^\/#(\/mcp\/consent\/[A-Za-z0-9_-]+)$/.exec(returnTo);
  return match?.[1] ?? null;
}